import * as React from "react";
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  makeStyles,
  Typography,
  Box,
  FormControl,
  FormHelperText,
} from "@material-ui/core";
import {
  Controller,
  useFormContext,
  useController,
  get, useWatch
} from 'react-hook-form';
// import { CustomSwitch } from "../Switch/Switch";
import Error from "../Error/Error";

import CircleChecked from "@material-ui/icons/CheckCircleOutline";
import CircleUnchecked from "@material-ui/icons/RadioButtonUnchecked";
import { white } from "../../constants/colors";
import {menuSettings} from "../../constants/settings";
import { getCheckPaymentPs } from '../../utils/productUtils';

const useStyles = makeStyles({
  radioStyles: {
    width: "100%",
    flexShrink: 0,

    "& .MuiFormControlLabel-root": {
      marginLeft: 0,
      marginRight: 0,
      display: "flex",
      alignItems: "self-start",
      marginBottom: "24px",
    },

    "& .MuiButtonBase-root": {
      color: "#D1D1D1",
      padding: 0,
      marginRight: "16px",
    },

    "& .MuiSwitch-root": {
      marginLeft: 0,
      "& .MuiButtonBase-root": {
        color: white,
      },
    },

    "& .MuiFormControlLabel-label": {
      opacity: 0.5,
    },

    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#00C908",

      "& +.MuiFormControlLabel-label": {
        opacity: 1,
      },
    },
  },
  subtitle: {
    fontSize: "14px",
    "& a": {
      marginLeft: "8px",
    },
  },

  subtitle1: {
    fontSize: 10,
  },

  formControl: {
    "& .MuiFormHelperText-root": {
      marginTop: "-10px",
    },
  },
  applyCare: {
    "& .MuiFormControlLabel-label": {
      opacity: 1,
    },
    "& span.MuiButtonBase-root": {
      color: "#00c908",
    },
  },
  declineCare: {
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#EB5757",
    },
  },
});

const CustomRadio = ({ ...props }) => {
  const { control, formState, getValues } = useFormContext();
  const classes = useStyles({ travelCare: props.travelCareValue });
  const { meta } = useController(props);
  const error = get(formState.errors, props.name);
  const errorText = meta.invalid ? error.message : "";

  const manualSplitValue =
    useWatch({ name: "manualSplit" }) || getValues("manualSplit");

  const acceptTipsValue =
    useWatch({ name: "acceptTips" }) || getValues("acceptTips");


  const inhouseCharge = () => {
    const ckPs = getCheckPaymentPs( props.selectedFlight ) + 1
    const {tbc, airline} = props.selectedFlight.taxes

    return manualSplitValue ? tbc + airline * ckPs : tbc
  }

  const airlineCharge = () => {
    const {tbc, airline} = props.selectedFlight.taxes
    return manualSplitValue ? 0 : airline
  }

  const priceOfferCalc = () => {
    return inhouseCharge() + airlineCharge()
  }

  const calcPrice = () => {
    let price = priceOfferCalc()

    // if (travelCareValue === "applyProtection") {
    //   price = price + props.selectedFlight?.travelCarePrice;
    // }
    // if (acceptTipsValue) {
    //   price = price + Number(props.tipsValue);
    // }
    return price.toFixed(2);
  };

  return (
    <FormControl error={!!errorText} className={classes.formControl}>
      <Box className={classes.radioStyles} mt={3}>
        <Controller
          {...props}
          as={
            <RadioGroup aria-label="flight">
              <FormControlLabel
                value="applyProtection"
                className={classes.applyCare}
                control={
                  <Radio
                    icon={<CircleUnchecked />}
                    checkedIcon={<CircleChecked />}
                  />
                }
                label={
                  <Box>
                    <Box mb={1}>
                      <Typography variant="body2">
                        <Box className="red">Recommended</Box>
                        Yes, I would like to add Ticket Protection to my
                        purchase for
                        <span className="green">{` $${
                          props?.selectedFlight?.travelCarePrice?.toFixed(2) ||
                          0
                        }`}</span>
                      </Typography>
                    </Box>
                    <Typography className={classes.subtitle}>
                      I confirm that I have read and agreed to the
                      <a href={menuSettings.link.terms} className="blue">
                        Terms and Conditions
                      </a>
                    </Typography>
                    {/* {props.watchFields.travelCare === "applyProtection" && (
                    <Box>
                      {props.watchFields.passengers.map((item, idx) => (
                        <>
                          {console.log(props.watchFields.passengers,)}
                          <CustomSwitch
                            name={`passengers[${idx}].ticketCare`}
                            key={idx}
                            defaultValue={item.ticketCare}
                            label={
                              <Typography variant="body2">
                                {`${item.firstName} ${item.lastName}`}
                                <span className="green">
                                  {` (+$${props.singleTicketProtection.toFixed(
                                    2
                                  )})`}
                                </span>
                              </Typography>
                            }
                          />
                        </>
                      ))}
                    </Box>
                  )} */}
                  </Box>
                }
              />
              <FormControlLabel
                value="declineProtection"
                control={
                  <Radio
                    icon={<CircleUnchecked />}
                    checkedIcon={<CircleChecked />}
                  />
                }
                className={classes.declineCare}
                label={
                  <Box>
                    <Typography variant="body2">{`No, I’m willing to risk my $${
                      calcPrice()
                    } flight.`}</Typography>
                    <Box mt={1}>
                      <Typography className={classes.subtitle}>
                        I understand by declining this coverage that I may be
                        responsible for cancellation fees and delay expenses.
                      </Typography>
                    </Box>
                  </Box>
                }
              />
            </RadioGroup>
          }
          control={control}
        />
      </Box>
      <FormHelperText>
        {errorText && <Error errorMessage={errorText} />}
      </FormHelperText>
    </FormControl>
  );
};

export default CustomRadio;
